
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export const RegisterFeatures = () => {
  return (
    <div className="relative z-20 mt-auto">
      <div className="mb-12">
        <img
          src="/images/hero.png"
          alt="People using financial services"
          className="mx-auto h-64 w-auto object-cover rounded-lg shadow-md"
        />
      </div>
      <div className="space-y-4 bg-white/80 backdrop-blur-sm p-6 rounded-lg shadow-sm">
        <p className="text-lg font-medium">
          Join thousands of users who trust our platform for:
        </p>
        <ul className="space-y-2">
          <li className="flex items-center">
            <Check className="mr-2 h-5 w-5 text-primary" /> Secure Financial Management
          </li>
          <li className="flex items-center">
            <Check className="mr-2 h-5 w-5 text-primary" /> Easy Loan Applications
          </li>
          <li className="flex items-center">
            <Check className="mr-2 h-5 w-5 text-primary" /> Real Estate Investments
          </li>
          <li className="flex items-center">
            <Check className="mr-2 h-5 w-5 text-primary" /> Vendor Partnerships
          </li>
        </ul>
      </div>
      <div className="mt-8 text-center">
        <Link 
          to="/"
          className="text-primary hover:text-primary/80 hover:underline inline-flex items-center font-medium"
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};
